import React, { useEffect, useState } from 'react'
import PageHeading from '../../../components/PageHeading'
import InputBoxNumber from '../../../components/InputBoxNumber'
import { Button } from 'bootstrap'
import { useNavigate } from 'react-router-dom'
import GetProject from '../../../APIs/Project/GetProjectById'
import GetProjectDetailsByProjectId from '../../../APIs/Project/GetProjectDetailsByProjectId'
import InsertProjectLandAndCostSpecification from '../../../APIs/Project/InsertProjectLandAndCostSpecification'
import Loader from '../../../components/Loader';
import SideMessage from '../../../components/SideMessage';
export default function CreatePortfolio() {

    const [investorsDetails, setInvestorsDetails] = useState([]);

    const [sendForm, setSendForm] = useState({
        "projectId": 0,
        "totalArea": 0,
        "wastePercentage": 0,
        "wasteArea": 0,
        "plottedArea": 0,
        "purchaseCost": 0,
        "developmentCost": 0,
        "expenseCost": 0,
        "commission": 0,
        "investorAmount": 0,
        "sumAmount": 0,
        "productionCost": 0,
        "operationalCost": 0,
        "profitAmount": 0,
        "finalProductionCost": 0,
        "investorPlottedArea": 0,
        "areaUnit": 0,
        "userId": window.userId

    })
    const [activeInvestor, setActiveInvestor] = useState(0);
    let [sideToster, setSideToster] = useState({
        show: 0,
        message: '',
        type: ''
    });
    let [loader, setLoader] = useState(0)
    const navigate = useNavigate();
    const calculateInvestorPlottedArea = (sendForm, investor) => {
        if (sendForm.wastePercentage !== null) {
            const wastePercent = sendForm.wastePercentage || 0;
            const totalArea = investor.landArea || 0;

            const areaPercent = totalArea * (wastePercent / 100);
            //    setSendForm((prev)=>({...prev,"investorPlottedArea": areaPercent}));
            return totalArea - areaPercent;
        }

    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        console.log("value", name, value.includes("-"));
        if (value.includes("-")) {
            setSendForm((prev) => ({
                ...prev,
                [name]: ""
            }));
            return;
        }
        // allow empty input
        if (value === "") {
            setSendForm((prev) => ({
                ...prev,
                [name]: ""
            }));
            // return;
        }

        // const num = parseFloat(value);
        // if (isNaN(num)) return;

        setSendForm((prev) => {
            let updated = { ...prev, [name]: value };

            const totalArea = parseFloat(updated.totalArea) || 0;
            const wastePercentage = parseFloat(updated.wastePercentage) || 0;
            const wasteArea = parseFloat(updated.wasteArea) || 0;
            const plottedArea = parseFloat(updated.plottedArea) || 0;

            // AREA CALCULATIONS
            if (name === "totalArea") {
                const waste = totalArea * (wastePercentage / 100);
                updated.wasteArea = waste;
                updated.plottedArea = totalArea - waste;
            }

            if (name === "wastePercentage") {
                let wastePercentage = parseFloat(value);

                if (isNaN(wastePercentage)) wastePercentage = 0;

                // Clamp between 0 and 100
                wastePercentage = Math.min(100, Math.max(0, wastePercentage));

                updated.wastePercentage = wastePercentage;

                let waste = totalArea * (wastePercentage / 100);
                updated.wasteArea = waste;
                console.log("totalArea", totalArea, waste)
                updated.plottedArea = totalArea - waste;
            }

            if (name === "wasteArea") {
                const percent = totalArea ? (wasteArea / totalArea) * 100 : 0;
                updated.wastePercentage = percent;
                updated.plottedArea = totalArea - wasteArea;
            }

            if (name === "plottedArea") {
                const waste = totalArea - plottedArea;
                updated.wasteArea = waste;
                updated.wastePercentage = totalArea ? (waste / totalArea) * 100 : 0;
            }

            // COST CALCULATIONS
            const purchaseCost = parseFloat(updated.purchaseCost) || 0;
            const developmentCost = parseFloat(updated.developmentCost) || 0;
            const expenseCost = parseFloat(updated.expenseCost) || 0;
            const commission = parseFloat(updated.commission) || 0;
            const roi = parseFloat(updated.totalROIAmount) || 0;

            const sum = purchaseCost + developmentCost + expenseCost + commission + roi;

            updated.sumAmount = sum;
            updated.productionCost = plottedArea ? sum / plottedArea : 0;
            console.log("updated.productionCost", updated.productionCost)
            const productionCost = parseFloat(updated.productionCost) || 0;
            const operationalCost = parseFloat(updated.operationalCost) || 0;
            const profitAmount = parseFloat(updated.profitAmount) || 0;

            updated.finalProductionCost =
                productionCost + operationalCost + profitAmount;

            return updated;
        });

    };

    function validateProjectData(data) {
        const errors = false;

        for (const key in data) {
            if (key === "userId" || key ==="investorAmount") continue;

            if (data[key] === "" || data[key] === null || data[key] === undefined) {
                return `${key} cannot be empty.`;
            } else if (typeof data[key] === "number" && data[key] <= 0) {
                return false;
            }
        }

        return errors;
    }

    const handleOnSave = async () => {
        try {
            let error = validateProjectData(sendForm)
            if (error === false) {
                setLoader(1)
                let response = await InsertProjectLandAndCostSpecification(sendForm);
                if (response.status === 1) {
                    setSideToster({
                        show: 1,
                        message: "Data Save!!",
                        type: 'Success'
                    })
                    setLoader(0)
                    navigate("/plotdefine/" + sendForm.finalProductionCost + "/" + sendForm?.plottedArea)
                }
                else {
                    setSideToster({
                        show: 1,
                        message: response.responseValue,
                        type: 'Alert'
                    })
                    setLoader(0)
                }
            }
            else {
                console.log("errors", error)
                setSideToster({
                    show: 1,
                    message: error,
                    type: 'Alert'
                })
                setLoader(0)
            }
        }
        catch (error) {
            setSideToster({
                show: 1,
                message: expect.message,
                type: 'Alert'
            })
            setLoader(0)
        }
    }

    const getProjectData = async () => {
        let projectId = JSON.parse(window.sessionStorage.getItem("ProjectData")).projectId
        let response = await GetProjectDetailsByProjectId(projectId)
        if (response.status === 1) {
            const data = response.responseValue.projectDtos[0]
            const projectLandAndCost = response.responseValue.projectLandAndCost[0]
            const investors = response.responseValue.landInvestors
            setInvestorsDetails(investors)
            let wasteArea = data.totalLandArea * (projectLandAndCost?.wastePercentage / 100);
            setSendForm((prev) => ({
                ...prev,
                projectId: data.id,
                totalArea: data.totalLandArea,
                wastePercentage: projectLandAndCost?.wastePercentage,
                wasteArea: wasteArea,
                plottedArea: data.totalLandArea - wasteArea,
                developmentCost: projectLandAndCost?.developmentCost,
                // expenseCost: projectLandAndCost?.expenseCost,
                commission: projectLandAndCost?.commission,
                sumAmount: projectLandAndCost?.sumAmount,
                productionCost: projectLandAndCost?.productionCost,
                investorAmount: projectLandAndCost?.investorAmount,
                operationalCost: projectLandAndCost?.operationalCost,
                profitAmount: projectLandAndCost?.profitAmount,
                finalProductionCost: projectLandAndCost?.finalProductionCost,
                investorPlottedArea: 0,
                purchaseCost: parseFloat(data.totalLandPrice),
                areaUnit: data.unitName,
                expenseCost: projectLandAndCost?.expenseCost ?? parseFloat(response.responseValue.totalExpense),
                totalROIAmount: data.totalROIAmount,

            }))
        }
        else {

        }
    }

    useEffect(() => {
        setSendForm((prev) => ({
            ...prev,
            finalProductionCost: parseFloat(sendForm.profitAmount) + parseFloat(sendForm.operationalCost) + parseFloat(sendForm.productionCost)
        }))
    }, [sendForm.productionCost])

    useEffect(() => {
        getProjectData();
    }, [])

    return (
        <>
            <div className='d-flex flex-column flex-md-row justify-content-between pe-3 ps-3'>
                <PageHeading pagename={"Create Portfolio"} />
            </div>

            <div className='row pb-3 mt-3'>

                {/* Left Part */}
                <div className='col col-md-8'>
                    <div className='d-flex flex-column gap-3'>
                        {/* top part */}
                        <div className='container-fluid landformconatiner p-4'>
                            <PageHeading pagename={"Land Specification"} />
                            <div className='wrapform pt-3'>
                                <div className='d-flex flex-column gap-1'>
                                    <label className='form-label d-flex flex-row justify-content-between'>Total Area ({sendForm.areaUnit})</label>
                                    <input type='number' className='form-input-box' value={Math.round(sendForm.totalArea * 100) / 100} placeholder='Enter Total Area' name='totalArea' />
                                </div>
                                <div className='d-flex flex-column gap-1'>
                                    <label className='form-label d-flex flex-row justify-content-between'>Waste % </label>
                                    <input type='number' className='form-input-box' value={sendForm?.wastePercentage ? Math.round(sendForm?.wastePercentage * 100) / 100 : ""} placeholder='Enter Waste Percentage' name='wastePercentage' onChange={handleChange} />

                                </div>
                                <div className='d-flex flex-column gap-1'>
                                    <label className='form-label d-flex flex-row justify-content-between'>Waste Area ({sendForm.areaUnit})</label>
                                    <input type='number' className='form-input-box' value={sendForm.wasteArea ? Math.round(sendForm.wasteArea * 100) / 100 : ""} placeholder='Enter Waste Area' name='wasteArea' onChange={handleChange} />
                                </div>
                                <div className='d-flex flex-column gap-1'>
                                    <label className='form-label d-flex flex-row justify-content-between'>Plotted Area ({sendForm.areaUnit})</label>
                                    <input type='number' className='form-input-box' value={sendForm.plottedArea ? Math.round(sendForm.plottedArea * 100) / 100 : ""} placeholder='Enter Plotted Area' name='plottedArea' onChange={handleChange} />
                                </div>
                            </div>
                        </div>

                        {/* bottom part*/}

                        <div className='container-fluid landformconatiner p-4'>
                            <PageHeading pagename={"Cost Specification"} fontSize="25px" />
                            <div className='d-flex flex-row justify-content-between align-items-center mt-5'>
                                <label className='form-label d-flex flex-row justify-content-between col-6 fw-bold'>Land Purchase Cost</label>
                                <input type='number' className='form-input-box col-6' value={sendForm.purchaseCost ? Math.round(sendForm.purchaseCost * 100) / 100 : ""} placeholder='Enter Purchase Cost' name='purchaseCost' onChange={handleChange} />

                            </div>
                            <hr />
                            <div className='d-flex flex-row justify-content-between align-items-center mt-3'>
                                <label className='form-label d-flex flex-row justify-content-between col-6 fw-bold'>Estimate Development Cost</label>
                                <input type='number' className='form-input-box col-6' value={sendForm?.developmentCost ? Math.round(sendForm.developmentCost * 100) / 100 : ""} placeholder='Enter Development Cost' name='developmentCost' onChange={handleChange} />

                            </div>
                            <hr />
                            <div className='d-flex flex-row justify-content-between align-items-center mt-3'>
                                <label className='form-label d-flex flex-row justify-content-between col-6 fw-bold'>Legal Expenses Cost</label>
                                <input type='number' className='form-input-box col-6' value={sendForm.expenseCost ? Math.round(sendForm.expenseCost * 100) / 100 : ""} placeholder='Enter Expense Cost' name='expenseCost' onChange={handleChange} />

                            </div>
                            <hr />
                            <div className='d-flex flex-row justify-content-between align-items-center mt-3'>
                                <label className='form-label d-flex flex-row justify-content-between col-6 fw-bold'>Commission Given</label>
                                <input type='number' className='form-input-box col-6' value={sendForm.commission ? Math.round(sendForm.commission * 100) / 100 : ""} placeholder='Enter Commission' name='commission' onChange={handleChange} />

                            </div>
                            {
                                investorsDetails.length > 0 && (
                                    <>
                                        <hr />
                                        <div className='d-flex flex-row justify-content-between align-items-center mt-3'>
                                            <label className='form-label d-flex flex-row justify-content-between col-6 text-info fw-bold' >Investor ROI Amount</label>
                                            <input type='number' className='form-input-box col-6 text-info' value={Math.round(sendForm.totalROIAmount * 100) / 100} placeholder='Enter Investor Amount' name='totalROIAmount' disabled={true} />

                                        </div>
                                    </>
                                )
                            }

                            <hr />
                            <div className='d-flex flex-row justify-content-between align-items-center mt-3 '>
                                <label className='form-label d-flex flex-row justify-content-between col-6 text-success fw-bold'>Sum Amount</label>
                                <input type='number' className='form-input-box col-6 text-success' value={Math.round(sendForm.sumAmount * 100) / 100} placeholder='Enter Sum Amount' name='sumAmount' disabled={true} />

                            </div>

                        </div>
                        <div className='container-fluid landformconatiner p-4'>
                            <PageHeading pagename={"Production Cost Specification"} fontSize="25px" />
                            <div className='d-flex flex-row justify-content-between align-items-center mt-5'>
                                <label className='form-label d-flex flex-row justify-content-between col-6 fw-bold'>Production Cost Per SQF</label>
                                <input type='number' className='form-input-box col-6' value={sendForm.productionCost ? Math.round(sendForm.productionCost * 100) / 100 : ""} placeholder='Enter Production Cost Per SQF' name='productionCost' disabled={true} />

                            </div>
                            <hr />
                            <div className='d-flex flex-row justify-content-between align-items-center mt-3'>
                                <label className='form-label d-flex flex-row justify-content-between col-6 fw-bold' >Operational Cost Per SQF</label>
                                <input type='number' className='form-input-box col-6' value={sendForm.operationalCost ? Math.round(sendForm.operationalCost * 100) / 100 : ""} placeholder='Enter Operational Cost' name='operationalCost' onChange={handleChange} />
                            </div>
                            <hr />
                            <div className='d-flex flex-row justify-content-between align-items-center mt-3'>
                                <label className='form-label d-flex flex-row justify-content-between col-6 fw-bold'>Company Profit Per SQF</label>
                                <input type='number' className='form-input-box col-6' value={sendForm.profitAmount ? Math.round(sendForm.profitAmount * 100) / 100 : ""} placeholder='Enter Profit Amount' name='profitAmount' onChange={handleChange} />

                            </div>
                            <hr />
                            <div className='d-flex flex-row justify-content-between align-items-center mt-3'>
                                <label className='form-label d-flex flex-row justify-content-between col-6 fw-bold'>Per SQF Selling Cost</label>
                                <input type='number' className='form-input-box col-6' value={sendForm.finalProductionCost ? Math.round(sendForm.finalProductionCost * 100) / 100 : ""} placeholder='Enter Production Cost' name='finalProductionCost' onChange={handleChange} />

                            </div>
                        </div>
                    </div>
                    <button className='btn export-save-btn mt-3' onClick={handleOnSave}> Save & Next</button>
                </div>

                {/* right part */}
                <div className={`col col-md-4 d-${investorsDetails.length > 0 ? 'block' : 'none'}`}>
                    <div className="accordion" id="investorAccordion" >
                        {
                            investorsDetails && investorsDetails.map((investor, index) => {
                                const plottedAreainvestor = calculateInvestorPlottedArea(sendForm, investor);
                                return (
                                    <div className="accordion-item mb-3" key={index}>

                                        <h2 className="accordion-header" id={`heading${index}`}>
                                            <button
                                                type="button"
                                                onClick={() => setActiveInvestor(activeInvestor === index ? null : index)}
                                                className={`accordion-button ${activeInvestor === index ? "" : "collapsed"}`}
                                            >
                                                Investor {investor?.investorName}
                                            </button>
                                        </h2>

                                        <div
                                            id={`collapse${index}`}
                                            className={`accordion-collapse collapse ${activeInvestor === index ? "show" : ""}`}
                                            aria-labelledby={`heading${index}`}
                                        >
                                            <div className="accordion-body container-fluid landformconatiner p-4">

                                                <PageHeading pagename={"Investor"} />

                                                <div className='d-flex flex-row justify-content-between align-items-center mt-3'>
                                                    <label className='form-label col-6'>Total Area</label>
                                                    <input type='number' className='form-input-box col-6' value={Math.round(investor?.landArea * 100) / 100} placeholder='Enter Area' disabled={true} readOnly />
                                                </div>

                                                <hr />

                                                <div className='d-flex flex-row justify-content-between align-items-center mt-3'>
                                                    <label className='form-label col-6'>Invested Amount</label>
                                                    <input type='number' className='form-input-box col-6' value={investor?.investedAmount} placeholder='Enter Amount' disabled={true} readOnly />
                                                </div>

                                                <hr />

                                                <div className='d-flex flex-row justify-content-between align-items-center mt-3'>
                                                    <label className='form-label col-6'>ROI(Per Year)%</label>
                                                    <input type='number' className='form-input-box col-6' value={investor?.inflationPercentage} placeholder='Enter ROI' name='inflationPercentage' disabled={true} readOnly />
                                                </div>

                                                <hr />

                                                <div className='d-flex flex-row justify-content-between align-items-center mt-3'>
                                                    <label className='form-label col-6'>Amount To Be Return</label>
                                                    <input type='number' className='form-input-box col-6' value={investor.totalAmountToReturn} placeholder='Enter Amount To Be Return' disabled={true} readOnly />
                                                </div>

                                                <hr />

                                                <div className='d-flex flex-row justify-content-between align-items-center mt-3'>
                                                    <label className='form-label col-6'>Plotted Area</label>
                                                    <input type='number' className='form-input-box col-6' value={plottedAreainvestor.toFixed(2)} placeholder='Enter Area' name='investorPlottedArea' disabled={true} readOnly />
                                                </div>

                                                <hr />

                                                <div className='d-flex flex-row justify-content-between align-items-center mt-3'>
                                                    <label className='form-label col-6'>Per SQF Amount to Return</label>
                                                    <input type='number' className='form-input-box col-6' value={Math.round((investor.totalAmountToReturn / plottedAreainvestor) * 100) / 100} placeholder='Enter Per SQF Amount to Return' name='perSQFAmountToReturn' disabled={true} readOnly />
                                                </div>

                                                <hr />

                                                {/* <div className='d-flex flex-row justify-content-between align-items-center mt-3'>
                                                    <label className='form-label col-6'>Total Amount To Be Return</label>
                                                    <input type='number' className='form-input-box col-6' value={sendForm.waste} placeholder='Enter Total Amount To Be Return' name='waste' onChange={handleChange} />
                                                </div> */}

                                            </div>
                                        </div>

                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className='container-fluid landformconatiner p-4 mt-3 ' style={{ backgroundColor: "#3E4095", color: "white" }}>
                        <PageHeading pagename={"Per SQF Selling Cost "} color="white" />
                        <div className='d-flex flex-column gap-4 mt-4 '>
                            <label>Amount</label>
                            <PageHeading pagename={"₹ " + (sendForm.finalProductionCost ? Math.round(sendForm.finalProductionCost * 100) / 100 : "").toString()} color="white" fontSize="35px" />
                        </div>
                    </div>
                </div>
            </div>

            <Loader show={loader} />
            {
                sideToster.show === 1 ?
                    <SideMessage close={setSideToster} show={sideToster.show} type={sideToster.type} message={sideToster.message} />
                    : ""
            }
        </>
    )
}
